// @flow
import * as React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import _ from "lodash";
import { Select } from '../Form';
import { below } from "../../assets/css/media";
import colors from '../../assets/css/colors';
import type { TRootStore } from '../../modules/types/store/index';
import * as selectors from '../../modules/selectors/index';
import { CoachPopup } from '../';

const HeaderWrapper = styled.div`
	width: 100%;
	box-shadow: ${colors.box_shadow};
	height: 50px;
	display: flex;
	background: #fff;
	justify-content: space-between;
	align-items: center;
	> div {
		height: 50px;
		display: flex;
	}
	${below.tablet`
		display: none;
	`};

`;

const BtnInner = styled.button`
	padding: 1em;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
	outline: none;
	width: 110px;
	font-size: 14px;
	border-left: none;
	border-right: none;
	border-top: 3px solid rgba(0,0,0,0);
	cursor: pointer;
	background: #fff;
	color: ${({ is_fc }) => is_fc ? colors.coachPurple : colors.nrlDarkGreen};
	border-bottom: 3px solid ${({ is_active, is_coach }) => {
		return is_active ?
			(is_coach ? colors.coachPurple : colors.nrlGreen) :
			'rgba(0,0,0,0)';
	}}
`;
const SelectWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	text-transform: uppercase;
	> div {
		min-width: 12em;
	}
	select {
		text-transform: uppercase;
	}

`;
const ControlsWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	padding-right: 7px;
`;

type Props = Object;
type State = {
	coach_open: boolean,
};
export class DraftTableHeaderComponent extends React.Component<Props, State> {
	state = {
		coach_open: false,
	};

	constructor(props: Props, state: State) {
		super(props, state);
		_.bindAll(this, [
			'handlePopup',
		]);
	}
	handlePopup() {
		const { coach_open } = this.state;
		this.setState({ coach_open: !coach_open });
	}
	render() {
		const {
			onTabClick,
			onSelectChange,
			isCoachActive = false,
			children,
			selectOptions = [],
			selectValue,
			has_assistant_coach
		} = this.props;

		return (
			<React.Fragment>
				<HeaderWrapper>
					<div>
						<BtnInner
							is_fc={false}
							is_active={!isCoachActive}
							is_coach={false}
							onClick={onTabClick}>
							Basic Stats
						</BtnInner>
						<BtnInner
							is_fc
							is_coach
							is_active={isCoachActive}
							data-is-coach={1}
							onClick={has_assistant_coach ? onTabClick : this.handlePopup}>
							Coach Stats
						</BtnInner>
					</div>
					<ControlsWrapper>
						{isCoachActive ? (
							<SelectWrapper>
								<div>
									<Select
										name="by_squad"
										is_disabled={false}
										color={colors.coachPurple}
										onChange={onSelectChange}
										value={selectValue}
									>
										{selectOptions.map(({ key, value }) => (
											<option key={key} value={key}>
												{value}
											</option>
										))}
									</Select>
								</div>
							</SelectWrapper>
						) : null}

						{children}
					</ControlsWrapper>
				</HeaderWrapper>
				{this.state.coach_open && (<CoachPopup
					closeClick={this.handlePopup}
				/>)}
			</React.Fragment>
		);
	}
}
const mapStateToProps = (state: TRootStore) => ({
	has_assistant_coach: Boolean(selectors.getUser(state).assistant_coach),
});

export const DraftTableHeader = connect(mapStateToProps)(DraftTableHeaderComponent);
export default DraftTableHeader;


// WEBPACK FOOTER //
// ./src/components/DraftTableHeader/index.js